import {NavigationTableResponseItemModel} from './file-table.model';
import {MemberModel} from './user.model';
import {ValuePropertyModel} from './property.model';

export interface FileModel {
    chain_hash: string;
    created_at: string;
    description: string;
    global_registry_id: number;
    is_crypto: boolean;
    is_signature_file: boolean;
    key: string;
    master: boolean;
    name: string;
    owner_guid: string;
    collection_id: number;
    collection_name: string;
    signed: boolean;
    type_str: 'file' | 'collection' | 'folder';
    updated_at: string;
    latest_version: VersionsModel;
    versions: VersionsModel[];
    pdf_version: PdfVersionsModel;
    can_be_deleted: boolean;

    is_approved: boolean;

    custom_properties: ValuePropertyModel[];

    type_approve: null | 'all' | 'any';
    signers_guids: ISignersGuidsModel[],
    approvers_guids:ISignersGuidsModel[],
    approve_deadline_at:string,
    sign_deadline_at:string
}

export interface VersionsModel {
    created_at: string;
    description: string;
    id: number;
    name: string;
    guid_owner: string;
    owner: MemberModel;
    type_str: string;
    status: string;
    key: string;
}

export class PdfVersionsModel {
    constructor(
        public created_at?: string,
        public key?: string,
        public md5?: string,
        public name?: string,
        public status?: string,
        public description?: string /* TODO virtual */
    ) {
    }
}

export interface IApproverResModel {
    approver:{
        user: MemberModel;
        sign: boolean;
        sign_at: string;
    }
    message:string
}
export interface SignersOrVisorsModel {
    user?: MemberModel;
    member_guid: string;
    sign: boolean;
    sign_at: string;
}
export interface  ISignersGuidsModel {
    member_guid: string;
    sign: boolean;
    sign_at: string;
}

export interface FileUpload {
    source: {
        document: any;
        id?: number,
        file_description?: string;
        collection_description?: string;
        signers?: string;
    };
    file_name: string;
}

export interface SearchElement {
    id: number;
    name: string;
    owner: string;
    pid_id: number;
    type: string;
    updated_at: string;
}

export interface RegistryFileModel {
    chain_hash: string;
    created_at: string;
    description: string;
    global_registry_id: string;
    key: string;
    name: string;
    owner: MemberModel;
    pdf_key: string;
    signed_at: string;
    signers_guids: SignersOrVisorsModel[];
    type_str: string;
    updated_at: string;

    collapse?: boolean;
}

export interface DocsPermissions {
    role_type?: 'member' | 'department' | 'division';
    role_key?: string | number;
    is_create_folder: boolean;
    is_edit_settings: boolean;
    is_edit_singer: boolean;
    is_locked_collection: boolean;
    is_read_all: boolean;
    is_read_my_doc?: boolean;
    is_sighting_read: boolean;
    is_upload_file: boolean;
    use_custom_rights?: boolean;
}

export interface IDocumentApiResponse {
    document: FileModel,
    right: DocsPermissions,
    signers: SignersOrVisorsModel[]
}

export interface FolderTree {
    children: FolderTree[],
    folder: NavigationTableResponseItemModel,
    rights: {
        current: DocsPermissions,
        find: DocsPermissions,
    }
}
export interface IEditFileSigners {
    group:FileModel,
    signer_guids:ISignersGuidsModel[]
}